module.exports = "/assets/f49753fd2fc9b1fa24e6a3d2f4a33305.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MY.png
// module id = 1631
// module chunks = 0